export const initialState = {
	messagesByTopic: {},
};

export default initialState;
